<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-06 14:56:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-08 15:53:10
 * @FilePath: /partner.chaoyongtuan.com/src/views/common/dialog/authDialog.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<div>
		<el-dialog title="提示" width="426px" show-close :visible.sync="visible" :close-on-click-modal="false">
			<div class="flex flex-align-center">
				<img src="@/assets/public/warning-org.png" class="warn-img" alt="" />
				<p class="fz-14 font-bold ml-6">账号是否授权成功？</p>
			</div>
			<div class="fz-14 mt-8 ml-22">
				若您授权失败，可 <span class="yx-color-primary pointer" @click="Confirm">重新授权</span> 或
				<el-tooltip placement="top">
					<img slot="content" :src="baseInfo.partner_auth_code" alt="" width="160" height="160" />
					<a href="javascript:;" class="fz-14 mr-20 yx-color-primary">联系客服</a>
				</el-tooltip>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="ok">否</el-button>
				<el-button type="primary" @click="ok">是</el-button>
			</div>
		</el-dialog>
		<authStatusResult ref="authStatusResult"></authStatusResult>
	</div>
</template>
<script>
import authStatusResult from './authStatusResult.vue';
import mixin from '@/mixins';
import { checkAuthorize } from '@/api/shopManage';
export default {
	components: {
		authStatusResult,
	},
	mixins: [mixin],
	data() {
		return {
			visible: false,
			link: '',
			content: '',
			platformId: '',
		};
	},
	methods: {
		show(value, platformId) {
			this.platformId = platformId;
			this.link = value;
			this.visible = true;
		},
		Confirm() {
			var a = document.createElement('a'); // 创建a标签
			a.style.display = 'none'; // 隐藏a标签
			a.href = this.link; // 文件下载地址
			a.target = '_blank';
			document.body.appendChild(a); // 将a标签插入到页面中
			a.click(); // 强制触发a便签的点击事件
			document.body.removeChild(a); // 移除a标
			this.visible = true;
		},
		no() {
			this.visible = false;
		},
		async ok() {
			const data = await checkAuthorize({ platform_id: this.platformId });
			if (!data.bind_status) {
				this.$refs.authStatusResult.show(data.bind_status, this.platformId, data.institution_url);
			}
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped>
.warn-img {
	width: 16px;
	height: 16px;
}
</style>
